module.exports = __webpack_public_path__ + "img/image06.4596aecf.jpg";